<template>
    <div>
        <div style="display: flex;align-items: center;justify-content: space-between;">
            <a-breadcrumb style="margin: 16px 0">
                <a-breadcrumb-item>主页</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectFirstMenu }}</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectSecondMenu }}</a-breadcrumb-item>
            </a-breadcrumb>
            <div>
                <a-button icon="sync" @click="onRefresh">刷新</a-button>
            </div>
        </div>
        <a-collapse expandIconPosition="right" activeKey="1">
            <a-collapse-panel key="1" header="预设模板查询">
                <div class="qinang-search-row">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">服务商：</div>
                        <a-select v-model="query.facilitator_id">
                            <a-select-option :value="0">全部</a-select-option>
                            <a-select-option v-for="(item, index) in facilitatorList" :key="index"
                                :value="item.facilitatorId">{{ item.facilitatorName }}</a-select-option>
                        </a-select>
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">查询名称：</div>
                        <a-select v-model="query.query_config_id" @change="onQueryConfigChange">
                            <a-select-option :value="0">请选择</a-select-option>
                            <a-select-option v-for="(item, index) in prepareQueryList" :key="index"
                                :value="item.prepareQueryId">{{ item.queryName }}</a-select-option>
                        </a-select>
                    </div>
                    <div class="qinang-search-col-3"></div>
                </div>

                <a-divider style="margin: 20px 0;" />

                <a-form layout="vertical" v-if="paramList.length">
                    <div style="display: flex; flex-wrap: wrap; gap: 8px 12px; align-items: flex-start;">
                        <div v-for="(p, index) in paramList" :key="p.key" style="display: flex; align-items: center;">
                            <a-form-item style="margin-bottom: 0;">
                                <template #label>
                                    {{ p.label }}<span v-if="p.required" style="color:#f5222d;margin-left:4px;">*</span>
                                </template>

                                <a-input v-if="!p.input || p.input === 'text'" v-model="p.value" style="width: 240px"
                                    :placeholder="'请输入' + p.label" allow-clear />
                                <a-textarea v-else-if="p.input === 'textarea'" v-model="p.value" style="width: 240px"
                                    :placeholder="'请输入' + p.label" :rows="3" allow-clear />
                                <a-input-number v-else-if="p.input === 'number'" v-model="p.value" style="width: 200px"
                                    :placeholder="'请输入' + p.label" />
                                <a-select v-else-if="p.input === 'select' || p.input === 'multiple'" v-model="p.value"
                                    :mode="p.input === 'multiple' ? 'multiple' : undefined" style="width: 240px"
                                    :placeholder="'请选择' + p.label" allow-clear>
                                    <a-select-option v-for="opt in (p.options || [])" :key="opt.value"
                                        :value="opt.value">{{ opt.label
                                        }}</a-select-option>
                                </a-select>
                                <a-switch v-else-if="p.input === 'switch'" v-model="p.value" />
                                <a-date-picker v-else-if="p.input === 'date'" v-model="p.value" style="width: 240px"
                                    valueFormat="YYYY-MM-DD" :placeholder="'请选择' + p.label" />
                                <a-date-picker v-else-if="p.input === 'dateTimePicker'" v-model="p.value"
                                    style="width: 240px" valueFormat="YYYY-MM-DD HH:mm:ss" :show-time="true"
                                    :placeholder="'请选择' + p.label" />
                                <a-month-picker v-else-if="p.input === 'monthPicker'" v-model="p.value"
                                    style="width: 240px" valueFormat="YYYY-MM" format="YYYY-MM"
                                    :placeholder="'请选择' + p.label" />
                                <a-select v-else-if="p.input === 'yearPicker'" v-model="p.value" style="width: 240px"
                                    :placeholder="'请选择' + p.label">
                                    <a-select-option v-for="y in p._yearOptions" :key="y" :value="y">{{ y
                                        }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </div>
                    </div>
                </a-form>
                <div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
                    <a-button type="primary" icon="search" :loading="tableLoading" @click="search">查询</a-button>
                    <a-button icon="redo" style="margin-left: 14px;" @click="resetQuery">重置</a-button>
                    <a-button type="primary" icon="download" :disabled="!tableData.length" @click="dowTable"
                        style="margin-left: 14px;">导出</a-button>
                </div>
            </a-collapse-panel>
        </a-collapse>
        <div class="qinang-card">
            <a-card title="查询结果"> </a-card>
            <a-table v-if="tableColumns.length" :columns="tableColumns" :data-source="tableData" :loading="tableLoading"
                row-key="__key" :scroll="{ x: true }" size="small"
                :pagination="{ current: currentPage, pageSize: pageSize, total: total, showSizeChanger: true, showQuickJumper: true, size: 'small', showTotal: t => `共 ${t} 条记录` }"
                @change="onTableChange" />

            <a-empty v-else-if="!tableLoading" description="请选择条件后点击查询" />
        </div>

    </div>
</template>

<script>
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import moment from 'moment'

export default {
    data() {
        return {
            moment,
            selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
            selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
            facilitatorList: [],
            prepareQueryList: [],
            query: {
                facilitator_id: 0,
                query_config_id: 0,
            },
            paramList: [],
            tableLoading: false,
            tableColumns: [],
            tableData: [],

            currentPage: 1,
            pageSize: 10,
            total: 0,
        }
    },
    methods: {
        async apiFacilitatorListForStaff() {
            const { data: res } = await this.$http.post(this.navigation.apiFacilitatorListForStaff, {
                staffId: window.sessionStorage.getItem('staffId')
            })
            if (res.code == 200) {
                this.facilitatorList = res.data || []
            }
        },
        async apiPrepareQueryList() {
            const { data: res } = await this.$http.post(this.navigation.apiPrepareQueryList, {
                page: 1,
                size: 1000,
            })
            if (res.code == 200) {
                this.prepareQueryList = res.data.list || []
            }
        },
        onRefresh() {
            this.apiFacilitatorListForStaff()
            this.apiPrepareQueryList()
            if (this.query.query_config_id && this.query.query_config_id !== 0) {
                this.search()
            }
        },

        onQueryConfigChange(prepareQueryId) {
            this.paramList = []
            if (!prepareQueryId || prepareQueryId === 0) return
            const found = this.prepareQueryList.find((it) => it.prepareQueryId === prepareQueryId)
            if (!found || !found.paramConfig || !found.paramConfig.trim()) return
            let json
            try {
                json = JSON.parse(found.paramConfig)
            } catch (e) {
                this.$message.error('该预设的 paramConfig JSON 解析失败，请联系管理员')
                return
            }
            this.paramList = Object.keys(json).map((key) => {
                const item = json[key] || {}
                const isYear = item.type === 'date' && (item.input || '') === 'yearPicker'
                // 年份下拉：当前年前后各 5 年
                const yearOptions = isYear
                    ? Array.from({ length: 11 }, (_, i) => String(new Date().getFullYear() - 5 + i))
                    : []
                return {
                    key,
                    label: item.label || key,
                    type: item.type || 'string',
                    input: item.input || '',
                    options: item.options || [],
                    required: item.required === true,
                    value: item.input === 'switch'
                        ? (item.default === true || item.default === 'true')
                        : (item.default !== undefined ? item.default : undefined),

                    _yearOptions: yearOptions,
                }
            })
        },
        buildReplaceValue() {
            const replaceValue = {}
            for (const p of this.paramList) {
                const v = p.value
                if (v === undefined || v === null || v === '') {
                    if (p.required) {
                        this.$message.error('请填写必填参数：' + p.label)
                        return null
                    }
                    continue
                }
                if (p.input === 'multiple' && Array.isArray(v)) {
                    //转 'v1','v2'，后端 IN (...) 直接使用
                    replaceValue[p.key] = v.map(x => "'" + String(x).replace(/'/g, "''") + "'").join(',')
                } else if (p.input === 'switch') {
                    // 确保发送布尔值，避免 'false' 被后端当真值
                    replaceValue[p.key] = (v === true || v === 'true')
                } else {
                    replaceValue[p.key] = v
                }
            }
            return replaceValue
        },

        async search() {
            if (this.query.query_config_id === 0) {
                this.$message.warning('请选择查询名称')
                return
            }
            const replaceValue = this.buildReplaceValue()
            if (replaceValue === null) return
            this.tableLoading = true
            try {
                const { data: res } = await this.$http.post(this.navigation.apiPrepareQueryExecute, {
                    query_config_id: this.query.query_config_id,
                    replaceValue,
                    page: this.currentPage,
                    size: this.pageSize,
                })
                if (res.code == 200) {
                    this.total = res.data.total || 0
                    const headers = res.data.headers || []
                    this.tableColumns = headers.map((colName) => ({
                        title: (scope) => {
                            const h = this.$createElement
                            const idx = this.tableColumns.findIndex((c) => c.dataIndex === colName)
                            const isFirst = idx <= 0
                            const isLast = idx === this.tableColumns.length - 1
                            return h('span', { style: 'display: inline-flex; align-items: center; gap: 4px;' }, [
                                h('a-icon', {
                                    attrs: { type: 'caret-left' },
                                    style: { cursor: isFirst ? 'not-allowed' : 'pointer', color: isFirst ? '#bfbfbf' : '#1890ff', fontSize: '12px' },
                                    on: { click: () => this.moveLeft(colName) },
                                }),
                                h('span', colName),
                                h('a-icon', {
                                    attrs: { type: 'caret-right' },
                                    style: { cursor: isLast ? 'not-allowed' : 'pointer', color: isLast ? '#bfbfbf' : '#1890ff', fontSize: '12px' },
                                    on: { click: () => this.moveRight(colName) },
                                }),
                            ])
                        },

                        dataIndex: colName,
                        key: colName,
                        align: 'center',
                        exportTitle: colName,
                    }))

                    this.tableData = (res.data.rows || []).map((row, idx) => {
                        const item = { __key: idx }
                        headers.forEach((h) => {
                            let v = row[h]
                            if (v !== null && typeof v === 'object') v = JSON.stringify(v)
                            item[h] = v
                        })
                        return item
                    })

                } else {
                    this.$message.error(res.msg)
                }
            } catch (e) {
                console.error(e)
            } finally {
                this.tableLoading = false
            }
        },

        async dowTable() {
            if (this.query.query_config_id === 0) {
                this.$message.warning('请选择查询名称')
                return
            }
            const replaceValue = this.buildReplaceValue()
            if (replaceValue === null) return
            try {
                // 分页后 tableData 只有当前页，导出要全量：传 export=true 让后端跳过 LIMIT
                const { data: res } = await this.$http.post(this.navigation.apiPrepareQueryExecute, {
                    query_config_id: this.query.query_config_id,
                    replaceValue,
                    export: true,
                })
                if (res.code != 200) {
                    this.$message.error(res.msg || '导出查询失败')
                    return
                }
                const headers = res.data.headers || []
                const rows = res.data.rows || []
                if (!rows.length) {
                    this.$message.warning('没有可导出的数据')
                    return
                }
                const aoa = [headers, ...rows.map((row) =>
                    headers.map((h) => {
                        let v = row[h]
                        if (v !== null && typeof v === 'object') v = JSON.stringify(v)
                        if (typeof v === 'string' && /^\d{16,}$/.test(v)) return { t: 's', v }
                        return v
                    })
                )]
                const ws = XLSX.utils.aoa_to_sheet(aoa)
                ws['!cols'] = headers.map(() => ({ wch: 18 }))
                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
                const etout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })

                const cfg = this.prepareQueryList.find((it) => it.prepareQueryId === this.query.query_config_id)
                const name = (cfg && cfg.queryName) || '自定义SQL查询'
               
                FileSaver.saveAs(
                    new Blob([etout], { type: 'application/octet-stream' }),
                    `${name}.xlsx`
                )
            } catch (e) {
                console.error(e)
            }
        },

        onTableChange(pagination) {
            this.currentPage = pagination.current
            this.pageSize = pagination.pageSize
            this.search()
        },


        resetQuery() {
            this.query = {
                facilitator_id: 0,
                query_config_id: 0,
            }
            this.paramList = []
            this.tableColumns = []
            this.tableData = []
            this.currentPage = 1
            this.total = 0
        },

        moveLeft(colName) {
            const idx = this.tableColumns.findIndex((c) => c.dataIndex === colName)
            if (idx <= 0) return
            const cols = [...this.tableColumns]
            const [moved] = cols.splice(idx, 1)
            cols.splice(idx - 1, 0, moved)
            this.tableColumns = cols
        },

        moveRight(colName) {
            const idx = this.tableColumns.findIndex((c) => c.dataIndex === colName)
            if (idx === -1 || idx >= this.tableColumns.length - 1) return
            const cols = [...this.tableColumns]
            const [moved] = cols.splice(idx, 1)
            cols.splice(idx + 1, 0, moved)
            this.tableColumns = cols
        },
    },
    created() {
        this.apiFacilitatorListForStaff()
        this.apiPrepareQueryList()
    },
}
</script>

<style scoped></style>
